import { render, staticRenderFns } from "./WorkDetail.vue?vue&type=template&id=1a9a4958&scoped=true"
import script from "./WorkDetail.vue?vue&type=script&lang=js"
export * from "./WorkDetail.vue?vue&type=script&lang=js"
import style0 from "./WorkDetail.vue?vue&type=style&index=0&id=1a9a4958&prod&scoped=true&lang=less"
import style1 from "./WorkDetail.vue?vue&type=style&index=1&id=1a9a4958&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9a4958",
  null
  
)

export default component.exports